import { Component, type ErrorInfo, type ReactNode } from "react";
import { reportError } from "./lib/reportError";

/** Last-resort boundary: avoids a blank page if a render throws. */
export class ErrorBoundary extends Component<{ children: ReactNode }, { failed: boolean }> {
  state = { failed: false };

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error("[ui] render error", error, info.componentStack);
    reportError(error, "render");
  }

  render() {
    if (this.state.failed) {
      return (
        <div className="container section status status-error" role="alert">
          <p>Algo salió mal / Something went wrong.</p>
          <button type="button" className="btn btn-primary" onClick={() => window.location.reload()}>
            Recargar / Reload
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
